export default __webpack_public_path__ + "static/media/dessert04.64fcf6d3.png";